module.exports = __webpack_public_path__ + "static/media/bq.5f9d7f64.svg";